export default __webpack_public_path__ + "static/media/delana.78986491.png";